import Api from "./Api";

const endpoint = "/probenplan";
export default {
    get(params) {
        var usedParams = {};
        Api.handleDefaultParams(params, usedParams);
        return Api.fetchData(endpoint, usedParams);
    },
    suggest(type, text) {
        return Api.fetchData(endpoint + "/suggestions/" + type, { text: text });
    },
    postSuggestion(type, suggestion) {
        return Api.postData(endpoint + "/suggestions/" + type, {
            text: suggestion
        });
    },
    deleteSuggestion(type, suggestion) {
        return Api.deleteData(endpoint + "/suggestions/" + type, {
            text: suggestion
        });
    },
    post(data) {
        return Api.postData(endpoint, data);
    },
    put(id, data) {
        return Api.putData(endpoint + "/" + id, data);
    },
    delete(id) {
        return Api.deleteData(endpoint + "/" + id);
    }
};
